import React, { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../../../agenticsaas/contexts/AuthContext';
import { useEffectiveAccess } from '../../../agenticsaas/contexts/EffectiveAccessContext';
import {
  canAccessDashboardView,
  getStoredDashboardPreference,
  resolveDashboardView,
  routeForDashboardView,
} from '../../../utils/dashboardPreferences';

/**
 * Redirects away if subscription + role cannot open this dashboard view.
 */
export default function RequireDashboardView({ view, children }) {
  const { user, initialized, loading: authLoading } = useAuthContext();
  const {
    role,
    applications,
    permissions,
    subscription,
    loading: accessLoading,
  } = useEffectiveAccess();
  const options = useMemo(
    () => ({
      orgRole: role,
      access: { role, applications, permissions, subscription, loading: accessLoading },
    }),
    [role, applications, permissions, subscription, accessLoading]
  );

  if (!initialized || authLoading || accessLoading) {
    return (
      <div className="py-12 flex justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!canAccessDashboardView(view, user, options)) {
    const fallback = resolveDashboardView(user, getStoredDashboardPreference(), options);
    return <Navigate to={routeForDashboardView(fallback)} replace />;
  }

  return children;
}
